"use client";

import React from "react";

export default function BrowserCheck({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
